<section class="pl-error-page__message pl-error-state">
  <se-fe-empty-state [seFeDataTitle]="'ACCESS_DENIED.title' | translate">
    <se-fe-icon seFeEmptyStateIcon seFeDataName="lock_thin" seFeDataSize="950" seFeDataColor="gray-900"></se-fe-icon>
    {{ 'ACCESS_DENIED.message' | translate }}
  </se-fe-empty-state>
</section>
